import React, { Component } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Button from '@material-ui/core/Button';
import api from "../../../api/backend"
import Notifier, { openSnackbar } from '../../notifier';

class News extends Component {
    state = { config: {}, news: '' }

    getConfiguration = () => {
        api.getConfiguration().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ config: json })
            }
        }).catch(() => { })
    }

    updateConfiguration = () => {
        const { news } = this.state
        api.updateConfiguration(news).then(([response, json]) => {
            if (response.status === 200) {
                openSnackbar({ message: 'บันทึกสำเร็จ' })
            } else {
                openSnackbar({ message: 'ไม่สามารถบันทึกได้' })
            }
        }).catch(() => {
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
        })
    }

    componentDidMount() {
        this.getConfiguration()
    }

    render() {
        const { config } = this.state
        return (
            <div>
                <Notifier />
                <Button variant="contained" color="primary" onClick={this.updateConfiguration}>บันทึก</Button>
                <br />
                <br />
                <CKEditor
                    editor={ClassicEditor}
                    data={config.news}
                    // onInit={ editor => {
                    //     // You can store the "editor" and use when it is needed.
                    //     console.log( 'Editor is ready to use!', editor );
                    // } }
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({ news: data })
                        // console.log( { event, editor, data } );
                    }}
                // onBlur={ editor => {
                //     console.log( 'Blur.', editor );
                // } }
                // onFocus={ editor => {
                //     console.log( 'Focus.', editor );
                // } }
                />
            </div>
        );
    }
}

export default News;